import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=686b0506&scoped=true&lang=pug"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"
import style0 from "./Create.vue?vue&type=style&index=0&id=686b0506&prod&lang=scss&scoped=true"
import style1 from "./Create.vue?vue&type=style&index=1&id=686b0506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686b0506",
  null
  
)

export default component.exports